import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  height: 65vh;
  overflow-y: scroll;
`;

export const Inner = styled.div`
  width: 800px;
  margin: auto;
  flex-direction: column;
  display: flex;
  @media (max-width: 768px) {
    width: 85%;
  }
`;

export const Header = styled.h1`
  color: var(--orange);
  font-size: 32px;
  padding-bottom: 0.3em;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

export const Entity = styled.div`
  color: var(--grayBlack);
  font-weight: var(--boldFont);
  border: 0.5px solid var(--orange);
  max-width: 690px;
  width: 99%;
  margin-bottom: 10px !important;
  margin: auto;

  @media (max-width: 1024px) {
    width: 90%;
  }
  /* @media (max-width: 978px) {
    width: 640px !important;
  } */
  &:first-of-type {
    margin-top: 1.5em;
  }
  /* ::-webkit-scrollbar {
    width: 50px;
  } */

  /* ::-webkit-scrollbar-thumb {
    background-color: var(--orange);
    border-radius: 20px;
    outline: 1px solid var(--yellowOrange);
  } */
`;

export const Question = styled.div`
  font: 25px;
  justify-content: space-between;
  cursor: pointer;
  display: flex;
  font-weight: normal;
  background: rgba(254, 254, 254, 0.9);
  padding: 0.5em 1.12em;
  align-items: center;
  margin-bottom: 0;
  border-bottom: 0.5px solid var(--orange);
  h3 {
    font-weight: 600;
    color: var(--orange);
  }
`;

export const Text = styled.p`
  max-height: 1190px;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  color: var(--black);
  background: rgba(254, 254, 254, 0.9);
  transition: max-height 0.23s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 0.9em 2.1em 0.7em 1.4em;
  user-select: none;
  white-space: pre-wrap;
  margin-bottom: 0;
  /* img {
    opacity: 0.9 !important;
  } */

  @media (max-width: 550px) {
    font-size: 15px;
  }
`;
